module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"all":"All","save":"Save","title":"Quick search","cancelLabel":"Cancel","subheader":{"text":"Choose which saved searches you want to show up in the menu.","title":"Quick search"}},"no":{"all":"Alle","save":"Lagre","title":"Hurtigsøk","cancelLabel":"Avbryt","subheader":{"text":"Velg hvilke av de lagrede hurtigsøkene som skal vises i menyen.","title":"Hurtigsøk"}}}')
  delete Component.options._Ctor
}
